import { render, staticRenderFns } from "./FinanceInvoices.vue?vue&type=template&id=2b7e60ba&scoped=true"
import script from "./FinanceInvoices.vue?vue&type=script&lang=js"
export * from "./FinanceInvoices.vue?vue&type=script&lang=js"
import style0 from "./FinanceInvoices.vue?vue&type=style&index=0&id=2b7e60ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e60ba",
  null
  
)

export default component.exports